import React from 'react';
import MinimalResume from "./minimal/MinimalResume";
import ElegantResume from "./elegant/ElegantResume";
import ModernResume from "./modern/ModernResume";
import TimelineResume from "./timeline/TimelineResume";

export default class Resume extends React.Component {
    render() {
        // 'Simple', 'Professional', 'Contemporary', 'Chronological'
        switch (this.props.resumeData.selectedTemplate) {
            case 'Simple':
                return <MinimalResume resumeData={this.props.resumeData} />
            case 'Professional':
                return <ElegantResume resumeData={this.props.resumeData} />
            case 'Contemporary':
                return <ModernResume resumeData={this.props.resumeData} />
            case 'Chronological':
                return <TimelineResume resumeData={this.props.resumeData} />
            default:
                return null;
        }
    }
}